module.exports = __webpack_public_path__ + "static/media/scheduled_pantry.5aee9816.mp3";